module.exports = __webpack_public_path__ + "static/media/dashboard.2ed15c0d.svg";